module.exports = __webpack_public_path__ + "img/text-logo.6c1667de.svg";